import loadImages from '../loadImages';
import HubfulApplication from './HubfulApplication';
import { tracker } from 'UserPreferencesUI/lib/tracker';
import { setPrimaryTracker } from 'usage-tracker-container';
loadImages();
setPrimaryTracker(tracker);
new HubfulApplication().start();